import React from 'react';

const Icons = ({displayNone}) => {
	return (
		<div className="iconcs" style={displayNone}>
		<svg>
			<symbol id="user-icon" viewBox="0 0 512.000000 512.000000">
				<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
				fill="#000000" stroke="none">
				<path d="M2370 4305 c-254 -48 -450 -153 -621 -332 -156 -163 -252 -353 -294
				-578 -23 -122 -16 -357 13 -467 63 -232 187 -433 357 -578 43 -36 82 -69 89
				-73 8 -6 7 -10 -4 -14 -35 -14 -160 -83 -226 -125 -411 -264 -695 -747 -721
				-1225 l-6 -113 165 0 165 0 6 103 c7 123 42 264 96 391 159 373 470 638 869
				743 132 34 371 43 512 19 491 -86 879 -434 1016 -911 23 -78 44 -205 44 -262
				0 -87 -9 -83 173 -83 l160 0 -6 113 c-17 334 -154 667 -386 934 -128 147 -289
				274 -473 373 l-97 51 74 60 c172 136 313 358 377 591 20 73 23 106 23 273 0
				176 -2 197 -28 290 -31 113 -95 253 -158 347 -127 188 -347 355 -569 431 -158
				54 -394 72 -550 42z m360 -330 c276 -63 501 -266 584 -527 141 -443 -109 -900
				-559 -1019 -111 -29 -279 -29 -389 0 -357 95 -596 400 -596 764 0 130 22 232
				74 342 103 218 316 391 541 438 92 20 263 21 345 2z"/>
				</g>
			</symbol>
		</svg>
		<svg>
			<symbol id="card-icon" viewBox="0 0 1024.000000 1024.000000">
				<g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
				fill="#000000" stroke="none">
				<path d="M920 8451 c-83 -26 -150 -82 -191 -161 -20 -38 -24 -60 -24 -140 0
				-84 3 -101 27 -146 15 -28 48 -70 73 -92 81 -71 86 -72 556 -72 l417 0 40
				-107 c22 -60 103 -274 180 -478 77 -203 423 -1121 770 -2040 347 -918 635
				-1682 641 -1696 9 -26 7 -29 -51 -65 -78 -48 -198 -161 -254 -241 -55 -75
				-115 -205 -140 -298 -27 -98 -27 -371 0 -465 93 -336 361 -589 695 -656 112
				-22 304 -15 411 16 307 87 546 334 626 648 23 89 25 110 21 252 -3 94 -11 176
				-20 208 l-15 52 905 0 c858 0 905 -1 898 -17 -35 -93 -46 -329 -20 -450 91
				-430 446 -723 875 -723 425 0 783 291 876 713 26 115 21 299 -10 419 -68 263
				-237 471 -480 588 -194 93 -3 84 -1956 88 l-1726 2 -81 215 -81 215 1967 0
				c2172 0 2024 -4 2113 63 23 18 55 50 70 72 21 30 137 396 458 1439 357 1161
				430 1409 430 1457 0 116 -61 218 -161 274 l-54 30 -3041 3 -3041 2 -88 233
				c-234 618 -274 719 -300 753 -32 42 -103 90 -155 104 -41 12 -1122 12 -1160 1z
				m3659 -2153 c18 -244 34 -455 37 -471 l6 -27 -707 2 -706 3 -169 446 c-92 245
				-171 455 -174 467 l-7 22 844 0 843 0 33 -442z m1728 405 c-3 -21 -20 -233
				-38 -470 l-33 -433 -653 0 c-646 0 -653 0 -653 20 0 25 -57 772 -65 858 l-7
				62 727 0 728 0 -6 -37z m1881 25 c-2 -7 -67 -219 -144 -470 l-139 -458 -677 0
				c-373 0 -678 1 -678 3 0 1 16 202 35 447 19 245 35 455 35 468 l0 22 786 0
				c625 0 785 -3 782 -12z m-3544 -1290 c3 -24 17 -196 31 -383 14 -187 27 -355
				29 -372 l5 -33 -532 0 -533 0 -144 383 c-79 210 -150 397 -157 415 l-13 32
				654 0 655 0 5 -42z m1566 30 c0 -7 -14 -182 -30 -388 -16 -206 -30 -387 -30
				-402 l0 -28 -565 0 c-315 0 -565 4 -565 9 0 5 -13 185 -30 401 -16 216 -30
				399 -30 406 0 12 102 14 625 14 493 0 625 -3 625 -12z m1590 0 c0 -7 -56 -193
				-124 -413 l-124 -400 -547 -3 -547 -2 6 47 c3 27 17 208 32 403 14 195 27 361
				30 368 5 18 1274 18 1274 0z m-3860 -2530 c184 -79 222 -324 71 -461 -57 -51
				-105 -70 -181 -70 -150 -1 -274 125 -274 278 0 134 95 248 227 275 52 10 99 3
				157 -22z m3513 -1 c89 -37 167 -154 167 -251 0 -98 -74 -212 -167 -257 -64
				-31 -151 -31 -218 -1 -210 95 -228 382 -30 498 80 46 156 50 248 11z"/>
				</g>
			</symbol>
		</svg>
		<svg>
			<symbol id="search-icon" viewBox="0 0 1007.000000 1007.000000">
				<g transform="translate(0.000000,1007.000000) scale(0.100000,-0.100000)"
				fill="#000000" stroke="none">
				<path d="M3200 8784 c-712 -97 -1335 -486 -1730 -1081 -393 -592 -508 -1327
				-316 -2023 156 -566 514 -1056 1019 -1393 118 -79 358 -199 501 -252 126 -47
				331 -99 476 -122 163 -26 577 -26 740 0 389 62 778 221 1072 439 l81 60 303
				-303 304 -304 -114 -115 c-63 -63 -119 -125 -125 -137 -6 -12 -11 -41 -11 -65
				l0 -43 1143 -1143 c628 -629 1156 -1151 1172 -1160 38 -20 121 -20 160 1 44
				23 842 827 855 860 20 54 12 119 -19 168 -16 24 -534 549 -1152 1166 -906 903
				-1130 1122 -1156 1128 -68 14 -90 0 -251 -158 l-153 -151 -299 299 -299 300
				51 65 c275 350 444 755 510 1225 19 136 16 504 -5 645 -170 1115 -1019 1949
				-2130 2095 -148 19 -481 18 -627 -1z m708 -508 c651 -138 1182 -577 1432
				-1184 55 -133 99 -290 127 -447 24 -139 24 -461 0 -600 -73 -419 -246 -767
				-532 -1064 -320 -332 -736 -537 -1200 -592 -157 -18 -442 -6 -593 25 -384 81
				-703 247 -979 510 -422 402 -652 994 -605 1561 39 473 225 890 547 1224 305
				317 697 519 1138 586 65 10 158 13 317 10 195 -3 241 -7 348 -29z"/>
				</g>
			</symbol>
		</svg>

		<svg>
			<symbol id="genre-icon" viewBox="0 0 1024.000000 1024.000000">
				<g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
					fill="#6c00aa" stroke="none">
					<path d="M8145 9330 c-16 -5 -734 -169 -1595 -365 -2418 -550 -2702 -615
					-2750 -636 -55 -25 -86 -52 -113 -104 l-22 -40 -3 -2707 c-1 -1490 -6 -2708
					-10 -2708 -4 0 -39 13 -79 29 -302 123 -672 139 -965 41 -321 -108 -555 -327
					-651 -610 -31 -93 -32 -98 -31 -275 0 -167 2 -187 27 -268 99 -321 318 -523
					650 -599 121 -28 359 -30 492 -5 198 38 413 127 559 231 248 177 402 420 435
					686 8 57 11 709 11 1979 0 1408 3 1904 12 1932 14 49 69 114 117 138 20 11
					821 206 1781 436 1340 320 1752 415 1780 410 51 -9 96 -38 117 -77 17 -31 18
					-110 21 -1512 2 -1188 0 -1477 -10 -1473 -218 96 -407 137 -628 137 -149 0
					-233 -11 -360 -47 -510 -142 -810 -564 -736 -1038 59 -381 284 -631 651 -726
					120 -31 393 -34 525 -6 483 103 838 397 962 797 l23 75 3 3095 c2 2098 0 3106
					-7 3131 -17 57 -52 82 -119 85 -31 2 -70 -1 -87 -6z"/>
				</g>
			</symbol>
		</svg>
		<svg>
			<symbol id="bpm-icon" viewBox="0 0 605.000000 462.000000">
				<g transform="translate(0.000000,462.000000) scale(0.100000,-0.100000)"
					fill="#000000" stroke="none">
					<path d="M2237 4116 c-18 -19 -20 -39 -57 -646 -11 -179 -29 -464 -40 -635
					-25 -380 -99 -1582 -102 -1648 -1 -27 -5 -50 -8 -52 -7 -5 -64 109 -61 121 2
					4 -2 10 -7 13 -5 3 -20 26 -32 51 -12 25 -28 48 -34 52 -6 4 -141 8 -301 8
					l-290 1 -40 56 c-44 60 -123 137 -189 182 -131 88 -247 82 -455 -24 -102 -53
					-164 -88 -171 -96 -3 -3 -41 -32 -85 -63 -71 -50 -85 -56 -130 -56 -71 0 -94
					-9 -101 -36 -11 -44 9 -54 112 -54 52 0 94 4 94 8 0 16 276 191 373 237 214
					102 295 69 529 -218 l23 -28 287 1 288 0 74 -149 c41 -82 72 -152 68 -156 -4
					-5 -2 -6 3 -2 6 3 16 -7 23 -22 19 -44 49 -70 72 -64 11 3 23 9 26 14 8 14 19
					174 84 1224 33 545 63 1015 67 1045 4 37 15 -102 34 -430 92 -1629 120 -2148
					117 -2176 -2 -18 3 -36 12 -46 15 -15 71 -48 58 -33 -4 4 0 14 9 20 11 9 47
					132 112 391 l96 379 387 5 387 5 93 105 c207 234 386 380 465 380 81 0 186
					-123 303 -355 l65 -130 161 -3 161 -2 144 96 c178 120 327 194 407 201 70 6
					114 -10 186 -69 54 -45 167 -167 175 -189 11 -34 30 -39 139 -39 61 0 117 3
					126 6 19 7 21 55 4 72 -7 7 -46 12 -103 12 l-90 1 -40 56 c-68 95 -185 192
					-273 226 -137 54 -333 -18 -642 -237 l-65 -46 -115 0 -115 0 -47 98 c-80 167
					-162 280 -258 353 -41 31 -50 34 -115 34 -57 0 -81 -5 -122 -27 -110 -57 -240
					-170 -398 -348 l-98 -110 -361 -1 c-199 0 -379 -3 -401 -7 l-39 -7 -60 -242
					c-33 -133 -61 -241 -63 -239 -2 1 -14 203 -28 447 -13 244 -29 523 -35 619 -6
					96 -33 585 -60 1085 -58 1069 -58 1061 -77 1080 -18 19 -38 19 -56 1z"/>
				</g>
			</symbol>
		</svg>
		<svg>
			<symbol id="energy-icon" viewBox="0 0 512.000000 512.000000">
				<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
				fill="#446cff" stroke="none">
				<path d="M2695 5088 c-26 -25 -199 -365 -740 -1453 -388 -781 -708 -1437 -711
				-1457 -8 -49 26 -120 70 -148 32 -19 48 -20 560 -20 325 0 526 -4 526 -9 0 -6
				-47 -430 -105 -944 -117 -1038 -115 -988 -46 -1034 25 -17 48 -23 88 -23 47 0
				58 4 87 33 26 24 214 385 728 1396 381 750 701 1384 711 1409 24 61 15 106
				-28 149 l-33 33 -549 0 -549 0 113 973 c69 595 110 988 106 1012 -4 28 -17 51
				-43 77 -35 35 -42 38 -94 38 -50 0 -60 -4 -91 -32z"/>
				<path d="M2115 4786 c-281 -58 -526 -154 -754 -298 -569 -358 -946 -930 -1047
				-1588 -22 -139 -29 -439 -15 -568 92 -806 561 -1474 1276 -1818 141 -68 364
				-149 375 -137 4 5 19 125 34 268 15 143 28 266 29 273 1 8 -23 23 -59 37 -707
				268 -1164 984 -1104 1732 50 614 413 1147 965 1415 l107 52 159 318 c87 175
				159 322 159 328 0 12 8 13 -125 -14z"/>
				<path d="M3165 4727 c-4 -18 -51 -438 -58 -515 -2 -20 10 -28 88 -60 256 -107
				473 -259 647 -457 750 -850 494 -2153 -523 -2673 l-113 -57 -164 -323 c-90
				-178 -162 -325 -159 -328 8 -8 198 32 314 65 414 119 799 367 1081 696 287
				334 474 748 533 1180 21 148 18 502 -4 640 -129 815 -658 1478 -1417 1778 -63
				25 -139 52 -167 61 -52 15 -53 15 -58 -7z"/>
				</g>
			</symbol>
		</svg>
		<svg>
			<symbol id="mood-icon" viewBox="0 0 529.000000 505.000000">
				<g transform="translate(0.000000,505.000000) scale(0.100000,-0.100000)"
				fill="#fb5359" stroke="none">
				<path d="M492 5025 c-30 -7 -92 -32 -140 -55 -123 -61 -214 -154 -275 -281
				-54 -111 -67 -169 -67 -289 0 -120 13 -178 67 -289 63 -131 153 -221 284 -284
				111 -54 169 -67 289 -67 120 0 178 13 289 67 131 63 221 153 284 284 54 111
				67 169 67 289 0 120 -13 178 -67 289 -63 131 -153 221 -284 284 -52 25 -118
				50 -147 56 -70 15 -234 13 -300 -4z m298 -90 c189 -50 345 -206 395 -395 19
				-71 19 -209 0 -280 -50 -189 -206 -345 -395 -395 -71 -19 -209 -19 -280 0
				-189 50 -345 206 -395 395 -19 71 -19 209 0 280 50 187 205 344 391 395 66 18
				216 18 284 0z"/>
				<path d="M390 4660 c-13 -13 -20 -33 -20 -60 0 -53 27 -80 80 -80 53 0 80 27
				80 80 0 53 -27 80 -80 80 -27 0 -47 -7 -60 -20z"/>
				<path d="M790 4660 c-13 -13 -20 -33 -20 -60 0 -53 27 -80 80 -80 53 0 80 27
				80 80 0 53 -27 80 -80 80 -27 0 -47 -7 -60 -20z"/>
				<path d="M293 4345 c11 -110 88 -217 194 -271 53 -27 67 -29 163 -29 96 0 110
				2 163 29 106 54 183 161 194 271 l6 55 -47 0 c-45 0 -46 -1 -46 -32 0 -45 -40
				-126 -81 -165 -107 -101 -286 -97 -386 8 -39 42 -72 113 -73 157 0 31 -1 32
				-46 32 l-47 0 6 -55z"/>
				<path d="M2492 5025 c-30 -7 -92 -32 -140 -55 -123 -61 -214 -154 -275 -281
				-54 -111 -67 -169 -67 -289 0 -120 13 -178 67 -289 63 -131 153 -221 284 -284
				111 -54 169 -67 289 -67 120 0 178 13 289 67 131 63 221 153 284 284 54 111
				67 169 67 289 0 120 -13 178 -67 289 -36 75 -59 108 -118 166 -58 59 -91 82
				-166 118 -52 25 -118 50 -147 56 -70 15 -234 13 -300 -4z m298 -90 c92 -24
				179 -75 250 -145 70 -71 121 -158 145 -250 19 -71 19 -209 0 -280 -50 -189
				-206 -345 -395 -395 -71 -19 -209 -19 -280 0 -189 50 -345 206 -395 395 -19
				71 -19 209 0 280 50 187 205 344 391 395 66 18 216 18 284 0z"/>
				<path d="M2390 4660 c-13 -13 -20 -33 -20 -60 0 -53 27 -80 80 -80 53 0 80 27
				80 80 0 27 -7 47 -20 60 -13 13 -33 20 -60 20 -27 0 -47 -7 -60 -20z"/>
				<path d="M2790 4660 c-13 -13 -20 -33 -20 -60 0 -27 7 -47 20 -60 13 -13 33
				-20 60 -20 27 0 47 7 60 20 13 13 20 33 20 60 0 27 -7 47 -20 60 -13 13 -33
				20 -60 20 -27 0 -47 -7 -60 -20z"/>
				<path d="M2535 4427 c-128 -42 -229 -164 -242 -292 l-6 -55 47 0 c45 0 46 1
				46 33 0 44 40 125 81 164 52 49 114 73 189 73 75 0 137 -24 189 -73 41 -39 81
				-120 81 -164 0 -32 1 -33 46 -33 l47 0 -6 55 c-11 110 -88 217 -194 270 -48
				25 -70 30 -147 32 -56 2 -107 -2 -131 -10z"/>
				<path d="M4492 5025 c-30 -7 -92 -32 -140 -55 -123 -61 -214 -154 -275 -281
				-54 -111 -67 -169 -67 -289 0 -120 13 -178 67 -289 63 -131 153 -221 284 -284
				111 -54 169 -67 289 -67 120 0 178 13 289 67 131 63 221 153 284 284 54 111
				67 169 67 289 0 120 -13 178 -67 289 -63 131 -153 221 -284 284 -52 25 -118
				50 -147 56 -70 15 -234 13 -300 -4z m298 -90 c189 -50 345 -206 395 -395 8
				-30 15 -93 15 -140 0 -155 -52 -281 -160 -390 -109 -108 -235 -160 -390 -160
				-155 0 -281 52 -390 160 -108 109 -160 235 -160 390 0 47 7 110 15 140 50 187
				205 344 391 395 66 18 216 18 284 0z"/>
				<path d="M4390 4660 c-13 -13 -20 -33 -20 -60 0 -27 7 -47 20 -60 13 -13 33
				-20 60 -20 27 0 47 7 60 20 13 13 20 33 20 60 0 27 -7 47 -20 60 -13 13 -33
				20 -60 20 -27 0 -47 -7 -60 -20z"/>
				<path d="M4790 4660 c-13 -13 -20 -33 -20 -60 0 -27 7 -47 20 -60 13 -13 33
				-20 60 -20 27 0 47 7 60 20 13 13 20 33 20 60 0 27 -7 47 -20 60 -13 13 -33
				20 -60 20 -27 0 -47 -7 -60 -20z"/>
				<path d="M4370 4240 l0 -40 280 0 280 0 0 40 0 40 -280 0 -280 0 0 -40z"/>
				<path d="M492 3145 c-30 -7 -92 -32 -140 -55 -123 -61 -214 -154 -275 -281
				-54 -111 -67 -169 -67 -289 0 -120 13 -178 67 -289 63 -131 153 -221 284 -284
				111 -54 169 -67 289 -67 120 0 178 13 289 67 131 63 221 153 284 284 54 111
				67 169 67 289 0 120 -13 178 -67 289 -63 131 -153 221 -284 284 -52 25 -118
				50 -147 56 -70 15 -234 13 -300 -4z m298 -90 c189 -50 345 -206 395 -395 19
				-71 19 -209 0 -280 -50 -189 -206 -345 -395 -395 -71 -19 -209 -19 -280 0
				-189 50 -345 206 -395 395 -19 71 -19 209 0 280 50 187 205 344 391 395 66 18
				216 18 284 0z"/>
				<path d="M362 2780 c-39 -24 -72 -75 -72 -112 0 -26 3 -28 43 -28 38 0 44 3
				54 30 20 53 106 53 126 0 10 -27 16 -30 54 -30 40 0 43 2 43 28 0 72 -73 132
				-160 132 -37 0 -66 -6 -88 -20z"/>
				<path d="M762 2780 c-39 -24 -72 -75 -72 -112 0 -26 3 -28 43 -28 38 0 44 3
				54 30 20 53 106 53 126 0 10 -27 16 -30 54 -30 40 0 43 2 43 28 0 72 -73 132
				-160 132 -37 0 -66 -6 -88 -20z"/>
				<path d="M334 2505 c-12 -29 2 -121 25 -167 28 -60 89 -120 149 -150 68 -33
				216 -33 284 0 106 52 173 153 173 262 l0 65 -313 3 c-275 2 -313 0 -318 -13z
				m540 -87 c-20 -66 -74 -127 -136 -152 -21 -9 -60 -16 -88 -16 -103 0 -193 67
				-224 168 l-7 22 231 0 231 0 -7 -22z"/>
				<path d="M2492 3145 c-30 -7 -92 -32 -140 -55 -123 -61 -214 -154 -275 -281
				-54 -111 -67 -169 -67 -289 0 -120 13 -178 67 -289 63 -131 153 -221 284 -284
				111 -54 169 -67 289 -67 120 0 178 13 289 67 131 63 221 153 284 284 54 111
				67 169 67 289 0 120 -13 178 -67 289 -36 75 -59 108 -118 166 -58 59 -91 82
				-166 118 -52 25 -118 50 -147 56 -70 15 -234 13 -300 -4z m298 -90 c92 -24
				179 -75 250 -145 70 -71 121 -158 145 -250 19 -71 19 -209 0 -280 -50 -189
				-206 -345 -395 -395 -71 -19 -209 -19 -280 0 -189 50 -345 206 -395 395 -19
				71 -19 209 0 280 50 187 205 344 391 395 66 18 216 18 284 0z"/>
				<path d="M2390 2780 c-13 -13 -20 -33 -20 -60 0 -53 27 -80 80 -80 53 0 80 27
				80 80 0 27 -7 47 -20 60 -13 13 -33 20 -60 20 -27 0 -47 -7 -60 -20z"/>
				<path d="M2790 2780 c-13 -13 -20 -33 -20 -60 0 -27 7 -47 20 -60 13 -13 33
				-20 60 -20 27 0 47 7 60 20 13 13 20 33 20 60 0 27 -7 47 -20 60 -13 13 -33
				20 -60 20 -27 0 -47 -7 -60 -20z"/>
				<path d="M2334 2505 c-12 -29 2 -121 25 -167 28 -60 89 -120 149 -150 68 -33
				216 -33 284 0 106 52 173 153 173 262 l0 65 -313 3 c-275 2 -313 0 -318 -13z
				m540 -87 c-20 -66 -74 -127 -136 -152 -21 -9 -60 -16 -88 -16 -103 0 -193 67
				-224 168 l-7 22 231 0 231 0 -7 -22z"/>
				<path d="M4492 3145 c-30 -7 -92 -32 -140 -55 -123 -61 -214 -154 -275 -281
				-54 -111 -67 -169 -67 -289 0 -120 13 -178 67 -289 63 -131 153 -221 284 -284
				111 -54 169 -67 289 -67 120 0 178 13 289 67 131 63 221 153 284 284 54 111
				67 169 67 289 0 120 -13 178 -67 289 -63 131 -153 221 -284 284 -52 25 -118
				50 -147 56 -70 15 -234 13 -300 -4z m298 -90 c189 -50 345 -206 395 -395 8
				-30 15 -93 15 -140 0 -155 -52 -281 -160 -390 -109 -108 -235 -160 -390 -160
				-155 0 -281 52 -390 160 -108 109 -160 235 -160 390 0 47 7 110 15 140 50 187
				205 344 391 395 66 18 216 18 284 0z"/>
				<path d="M4365 2800 l-29 -30 44 -45 44 -45 -47 0 -47 0 0 -40 0 -41 118 3
				117 3 3 29 c3 25 -8 41 -79 112 -46 46 -86 84 -89 84 -4 0 -19 -14 -35 -30z"/>
				<path d="M4811 2746 c-71 -71 -82 -87 -79 -112 l3 -29 118 -3 117 -3 0 41 0
				40 -47 0 -47 0 44 45 44 45 -29 30 c-16 16 -31 30 -35 30 -3 0 -43 -38 -89
				-84z"/>
				<path d="M4537 2505 c-113 -43 -207 -166 -207 -271 0 -34 1 -34 45 -34 42 0
				45 2 45 28 1 37 31 101 66 136 113 113 308 77 375 -69 10 -22 19 -52 19 -67 0
				-27 3 -28 46 -28 l47 0 -5 49 c-9 97 -81 196 -176 243 -59 29 -195 36 -255 13z"/>
				<path d="M492 1265 c-30 -7 -92 -32 -140 -55 -123 -61 -214 -154 -275 -281
				-54 -111 -67 -169 -67 -289 0 -120 13 -178 67 -289 63 -131 153 -221 284 -284
				111 -54 169 -67 289 -67 120 0 178 13 289 67 75 36 108 59 166 118 59 58 82
				91 118 166 54 111 67 169 67 289 0 120 -13 178 -67 289 -63 131 -153 221 -284
				284 -52 25 -118 50 -147 56 -70 15 -234 13 -300 -4z m298 -90 c189 -50 345
				-206 395 -395 19 -71 19 -209 0 -280 -50 -189 -206 -345 -395 -395 -71 -19
				-209 -19 -280 0 -189 50 -345 206 -395 395 -19 71 -19 209 0 280 50 187 205
				344 391 395 66 18 216 18 284 0z"/>
				<path d="M362 900 c-39 -24 -72 -75 -72 -112 0 -26 3 -28 43 -28 38 0 44 3 54
				30 20 53 106 53 126 0 10 -27 16 -30 54 -30 40 0 43 2 43 28 0 37 -33 88 -72
				112 -45 27 -131 27 -176 0z"/>
				<path d="M762 900 c-39 -24 -72 -75 -72 -112 0 -26 3 -28 43 -28 38 0 44 3 54
				30 20 53 106 53 126 0 10 -27 16 -30 54 -30 40 0 43 2 43 28 0 37 -33 88 -72
				112 -45 27 -131 27 -176 0z"/>
				<path d="M332 551 c9 -97 81 -196 176 -243 68 -33 216 -33 284 0 95 47 167
				146 176 243 l5 49 -47 0 c-43 0 -46 -1 -46 -27 -1 -38 -31 -102 -66 -137 -88
				-88 -240 -88 -328 0 -35 35 -65 99 -66 137 0 26 -3 27 -46 27 l-47 0 5 -49z"/>
				<path d="M2492 1265 c-30 -7 -92 -32 -140 -55 -123 -61 -214 -154 -275 -281
				-54 -111 -67 -169 -67 -289 0 -120 13 -178 67 -289 63 -131 153 -221 284 -284
				111 -54 169 -67 289 -67 120 0 178 13 289 67 131 63 221 153 284 284 54 111
				67 169 67 289 0 120 -13 178 -67 289 -63 131 -153 221 -284 284 -52 25 -118
				50 -147 56 -70 15 -234 13 -300 -4z m298 -90 c189 -50 345 -206 395 -395 19
				-71 19 -209 0 -280 -50 -189 -206 -345 -395 -395 -71 -19 -209 -19 -280 0
				-189 50 -345 206 -395 395 -19 71 -19 209 0 280 50 187 205 344 391 395 66 18
				216 18 284 0z"/>
				<path d="M2390 900 c-13 -13 -20 -33 -20 -60 0 -53 27 -80 80 -80 27 0 47 7
				60 20 13 13 20 33 20 60 0 53 -27 80 -80 80 -27 0 -47 -7 -60 -20z"/>
				<path d="M2790 900 c-13 -13 -20 -33 -20 -60 0 -53 27 -80 80 -80 53 0 80 27
				80 80 0 53 -27 80 -80 80 -27 0 -47 -7 -60 -20z"/>
				<path d="M2706 585 c-88 -31 -162 -122 -173 -213 l-6 -52 47 0 c43 0 46 2 46
				25 0 28 23 79 49 109 22 25 85 56 116 56 23 0 25 3 25 45 0 44 -1 45 -32 45
				-18 -1 -50 -7 -72 -15z"/>
				<path d="M4492 1265 c-30 -7 -92 -32 -140 -55 -123 -61 -214 -154 -275 -281
				-54 -111 -67 -169 -67 -289 0 -120 13 -178 67 -289 63 -131 153 -221 284 -284
				111 -54 169 -67 289 -67 120 0 178 13 289 67 131 63 221 153 284 284 54 111
				67 169 67 289 0 120 -13 178 -67 289 -63 131 -153 221 -284 284 -52 25 -118
				50 -147 56 -70 15 -234 13 -300 -4z m298 -90 c189 -50 345 -206 395 -395 8
				-30 15 -93 15 -140 0 -155 -52 -281 -160 -390 -109 -108 -235 -160 -390 -160
				-155 0 -281 52 -390 160 -108 109 -160 235 -160 390 0 47 7 110 15 140 50 187
				205 344 391 395 66 18 216 18 284 0z"/>
				<path d="M4217 913 c-4 -3 -7 -51 -7 -106 l0 -99 34 -34 34 -34 132 0 132 0
				34 34 c32 32 34 38 34 100 l0 66 40 0 40 0 0 -66 c0 -62 2 -68 34 -100 l34
				-34 132 0 132 0 34 34 35 35 -3 103 -3 103 -431 3 c-237 1 -434 -1 -437 -5z"/>
				<path d="M4332 511 c9 -97 81 -196 176 -243 68 -33 216 -33 284 0 95 47 167
				146 176 243 l5 49 -47 0 c-43 0 -46 -1 -46 -27 -1 -38 -31 -102 -66 -137 -88
				-88 -240 -88 -328 0 -35 35 -65 99 -66 137 0 26 -3 27 -46 27 l-47 0 5 -49z"/>
				</g>
			</symbol>
		</svg>
		<svg>
			<symbol id="dollar-icon" viewBox="0 0 512.000000 512.000000">
				<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
				fill="#08ac47" stroke="none">
				<path d="M2320 4981 l0 -139 -62 -7 c-109 -12 -270 -46 -368 -77 -335 -107
				-614 -330 -750 -598 -143 -284 -142 -698 5 -990 81 -163 240 -342 396 -447
				170 -115 386 -211 625 -278 71 -20 135 -38 142 -41 9 -3 12 -130 12 -594 0
				-324 -2 -590 -5 -590 -12 0 -93 45 -145 80 -170 115 -293 280 -360 483 l-22
				68 -41 -6 c-23 -3 -222 -21 -442 -41 -219 -19 -401 -37 -403 -39 -9 -9 23
				-146 60 -258 145 -442 445 -739 903 -895 106 -36 292 -78 388 -87 l67 -7 0
				-259 0 -259 250 0 250 0 0 264 0 264 28 6 c15 3 59 10 97 16 581 89 1039 416
				1205 862 53 145 65 222 64 438 0 191 -2 212 -27 304 -69 249 -210 443 -422
				582 -215 140 -439 225 -907 345 l-38 10 0 550 0 550 23 -7 c73 -22 192 -107
				247 -176 50 -63 76 -111 106 -198 21 -64 23 -65 55 -63 58 4 793 83 816 88 24
				6 23 13 -24 160 -151 472 -557 763 -1170 840 l-53 7 0 139 0 139 -250 0 -250
				0 0 -139z m0 -1271 l0 -490 -50 20 c-133 52 -281 173 -329 269 -89 173 -58
				364 82 517 67 73 228 171 285 174 9 0 12 -104 12 -490z m606 -1465 c300 -97
				453 -270 454 -511 0 -175 -98 -339 -269 -449 -69 -45 -177 -88 -248 -100 l-43
				-7 0 546 c0 456 2 546 14 546 7 0 49 -11 92 -25z"/>
				</g>
			</symbol>
		</svg>


					</div>
	);
}

export default Icons;
